import React from "react";
import {
  Container,
  Typography,
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  SvgIcon,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

export default function Timeline() {
  const milestones = [
    {
      year: "2024",
      items: [
        {
          title: "Frontend Developer @ Todak Digitech",
          description:
            "My first development experience and first job. I took the lead in designing and building responsive, user-friendly websites that matched what clients needed.",
        },
      ],
    },
    {
      year: "2023",
      items: [
        {
          title: "Created my first API with ExpressJS + MongoDB",
          description:
            "Developed my first MERN fullstack e-commerce app, ReactJS + ExpressJS + MongoDB.",
        },
        {
          title: "Took Web Backend Development with ExpressJS",
          description:
            "Developed Weather App Guide for users to search, using the OpenMeteo API and OpenCage API.",
        },
      ],
    },
    {
      year: "2022",
      items: [
        {
          title: "System Engineering Intern @ Ever AI Technologies",
          description:
            "My first experience in the IT world. Tested software, wrote test documentation, and worked on user and end-to-end testing. Dived into AI technologies.",
        },
        {
          title: "Featured on Hashnode for AI Prompt Engineering Guide",
          description:
            "Wrote a guide on Stable Diffusion image generation, praised for its clear explanations.",
        },
        {
          title:
            "Took Front-end Development + Software Engineering course @ TalentLabs Academy",
          description:
            "Kicked off my coding journey with HTML, CSS, JavaScript, and ReactJS. Built three projects using ReactJS.",
        },
        {
          title: "Finance Trainee @ HappyFresh Malaysia",
          description:
            "Handled verifying cash on delivery and matched daily e-wallet sales in a multinational company.",
        },
      ],
    },
    {
      year: "2021",
      items: [
        {
          title: "Graduated from UiTM",
          description:
            "Alhamdulillah, graduated with a First Class Bachelor of Accountancy (Honours).",
        },
        {
          title: "Accounting Intern @ Perbadanan Kemajuan Negeri Pahang (PKNP)",
          description:
            "Interned at a state government company, handled accounting tasks and learned government processes.",
        },
      ],
    },
  ];

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
      <Typography
        sx={{ textAlign: "left", fontWeight: "bolder", fontSize: 30 }}
      >
        ⏳ My Milestones
      </Typography>
      <Container maxWidth="md">
        {milestones.map((milestone) => (
          <Box key={milestone.year} sx={{ mb: 4 }}>
            <Typography
              sx={{ textAlign: "left", fontWeight: "bolder" }}
              variant="h6"
            >
              {milestone.year}
            </Typography>
            <List>
              {milestone.items.map((item, index) => (
                <ListItem key={index} alignItems="flex-start">
                  <ListItemIcon>
                    <SvgIcon
                      component={CheckCircleIcon}
                      sx={{ color: "violet" }}
                    />
                  </ListItemIcon>
                  <ListItemText
                    primary={<Typography variant="h6">{item.title}</Typography>}
                    secondary={item.description}
                  />
                </ListItem>
              ))}
            </List>
          </Box>
        ))}
      </Container>
    </Box>
  );
}
